<template>
  <router-view></router-view>
</template>

<script>
  export default {}
</script>


<style>
	
  .btn-custom {
    height:30px;margin-left: 20px;padding:0;margin-top:0 !important;
  }

  .pagination {
    display: inline-block;
    padding-left: 0;
    /*margin: 20px 0;*/
    border-radius: 4px;
  }

  .pagination > li {
    display: inline;
  }
  
  .pagination > li:first-child > a, .pagination > li:first-child > span {
    margin-left: 0;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  .pagination > .disabled > span, .pagination > .disabled > span:hover, .pagination > .disabled > span:focus, .pagination > .disabled > a, .pagination > .disabled > a:hover, .pagination > .disabled > a:focus {
    color: #777;
    cursor: not-allowed;
    background-color: #fff;
    border-color: #ddd;
  }
  
  .pagination > li > a, .pagination > li > span {
    position: relative;
    float: left;
    padding: 6px 12px;
    margin-left: -1px;
    line-height: 1.42857143;
    color: #337ab7;
    text-decoration: none;
    background-color: #fff;
    border: 1px solid #ddd;
  }
  .pagination > .active > a, .pagination > .active > span, .pagination > .active > a:hover, .pagination > .active > span:hover, .pagination > .active > a:focus, .pagination > .active > span:focus {
      z-index: 2;
      color: #fff;
      cursor: default;
      background-color: #337ab7;
      border-color: #337ab7;
  }

  .bordered-block-table {
    font-size: 12px; border: 1px solid #ddd; border-left: 0; border-right: 0; border-top: 0;
  }

  .bordered-block-table:first-child {
    border-top: 1px solid #ddd;
  }

  .f-10 {
    font-size: 10px !important;
  }

  .f-12 {
    font-size: 12px !important;
  }

  .f-14 {
    font-size: 14px !important;
  }

  .f-14 > tr > th {
    font-size: 14px !important;
  }

  .font-weight-bold > tr > th {
    font-weight: bold !important;
  }

  .fw-normal {
    font-weight: normal !important;
  }

  .text-grey {
    color: #888 !important;
  }

  .text-black {
    color: #000 !important;
  }

  .pointer {
    cursor: pointer !important;
  }

  .fw-normal > tr > th {
    font-weight: normal !important;
  } 
  
  .break-all {
    display: inline-block;
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: normal;
    line-break: strict;
    hyphens: none;
    -webkit-hyphens: none;
    -moz-hyphens: none;
  }

  .f-20 {
    font-size: 20px !important;
  }

  @media (max-width: 600px) {
    .hidden-mobile {
      display: none;
    }

    .text-center-mobile {
      text-align: center !important;
    }

    .mt-2-mobile {
      margin-top: 15px !important;
    }

    .only-mobile {
      /*display: inherit;*/
    }

    .f-20-mobile {
      font-size: 20px !important; 
    }

    .f-14-mobile {
      font-size: 14px !important;
    }

    .mx-auto-mobile {
      margin: 0 auto !important;
    }

    .mx-2-mobile {
      margin-left: 5px !important;
      margin-right: 5px !important;
    }

    .mb-2-mobile {
      margin-bottom: 15px !important;
      margin-bottom: 15px !important;
    }

    .my-2-mobile {
      margin-top: 5px !important;
      margin-bottom: 5px !important;
    }
  }

  @media (min-width: 601px) {
    .only-mobile {
      display: none;
    }
  }


  .bold {
    font-weight: bold;
  }
</style>